import { ReactComponent as CaretDownIcon } from "@common/assets/images/shared-icons/caret-down-icon.svg";
import Header from "@common/components/Header/Header";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled from "styled-components";

export const SelectedAppContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const SelectedAppWithOptions = styled.div`
  max-width: 36rem;
  display: flex;
  justify-content: space-between;
  z-index: 45;
  padding-right: 0.4rem;
`;

export const SelectedApp = styled.div`
  padding-left: 1rem;
  max-width: 28rem;
  display: flex;
  align-items: center;

  p {
    color: ${vars.colors.white};
    cursor: pointer;
  }
`;

export const AppNameParagraph = styled(Paragraph)<{ $wide?: boolean }>`
  max-width: 24rem;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  margin-right: 1rem;
`;

export const Disabled = styled.div`
  opacity: 0.4;
  cursor: default;

  span {
    opacity: 0.4;

    &:hover {
      opacity: 0.4;
    }
  }
`;

export const HeaderContainer = styled(Header)`
  position: relative;
`;

export const Down = styled(CaretDownIcon)`
  margin-left: 1rem;
`;
